import React from 'react';
import SquareButton from '../SquareButton';
import IconButton from '../IconButton';
import { ButtonProps, IconButtonProps } from '../../../types/components/button';

type ToggleButtonProps = {
  isOpen: boolean;
  selected?: boolean;
} & ButtonProps & IconButtonProps;

const ToggleButton: React.FC<ToggleButtonProps> = ({
    isOpen,
    onClick,
    label,
    small,
    bold,
    color,
    fullWidth,
    disabled,
    icon,
    selected,
    iconType,
    backgroundColor,
    tooltip,
    e2eTestId
}) => {

  return isOpen ? (
        <SquareButton
            label={label}
            onClick={onClick}
            fullWidth={fullWidth}
            color={backgroundColor}
            bold={bold}
            disabled={disabled}
            small={small}
            selected={selected}
            e2eTestId={e2eTestId}
        />
    ) : (
        <IconButton
            color={color}
            onClick={onClick}
            icon={icon}
            iconType={iconType}
            backgroundColor={backgroundColor}
            tooltip={tooltip}
            disabled={disabled}
            selected={selected}
            label={label}
            e2eTestId={e2eTestId}
        />
    );
};

export default ToggleButton;
